<div class="row">
  <div [ngClass]="_sideBar === true ? 'col-9' : 'col-lg-6'">
    <div class="row" *ngIf="_idDdc && _categorie && _typeDdc; else readOnlyBlock">
      <mat-form-field floatLabel="always" class="col">
        <ngx-mat-file-input #matFileUpload valuePlaceholder="Choisir le fichier"></ngx-mat-file-input>
        <button mat-icon-button matSuffix *ngIf="!matFileUpload.empty" (click)="matFileUpload.clear($event)">
          <mat-icon>clear</mat-icon>
        </button>
        <button mat-icon-button matSuffix *ngIf="matFileUpload.empty">
          <mat-icon matSuffix class="ddc-primary">folder</mat-icon>
        </button>
      </mat-form-field>

      <div *ngIf="_idDdc && _typeDdc && _categorie" class="col-auto ddc-textfield-btn-div">
        <button
          class="ddc-button-primary"
          mat-flat-button
          [disabled]="matFileUpload.empty"
          (click)="addSelectedFiles()">
          Importer
        </button>
      </div>
    </div>
    <ng-template #readOnlyBlock>
      <ng-container *ngIf="initiated === true">
        <div class="ddc-piece-jointe-readonly-title">
          <ng-container *ngIf="ddcFichiers && ddcFichiers.length > 0; else noPiecesJointesBlock">
            <span>La liste des pièces jointes téléchargées</span>
          </ng-container>
          <ng-template #noPiecesJointesBlock>
            <span>Aucune pièce jointe n'a été téléchargée</span>
          </ng-template>
        </div>
      </ng-container>
    </ng-template>
  </div>
</div>


<ng-container *ngIf="ddcFichiers && ddcFichiers.length > 0">
  <div class="row">
    <div class="col-12 ddc-piece-jointe-readonly-title">
      <span>
        Ci dessous les pièces jointes visibles sur cet onglet
      </span>
    </div>
  </div>
  <div *ngFor="let ddcFichier of ddcFichiers; let index = index" class="row ddc-piece-jointe-row">

    <div class="col-md-4">
      <div class="ddc-read-only-data-container ddc-padding-vertical">
        <span class="ddc-label">{{index + 1}} - {{ddcFichier.nom}}</span>
      </div>
    </div>

    <div class="col-md-5 ddc-piece-jointe-buttons-container">
      <button (click)="downloadSelectedFile(ddcFichier.id, ddcFichier.nom)" mat-flat-button color="accent">
        <i class="material-icons">cloud_download</i>
      </button>

      <button (click)="openDialogopenDialogSuppressionAttachment(ddcFichier.id)" mat-flat-button color="warn">
        <i class="material-icons">delete</i>
      </button>
    </div>

  </div>
</ng-container>
